export const GACHA_HISTORIES_KEY = "gacha_histories";
